import React from "react";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { EmptyState } from "/imports/ui/components/shared";

// Shown in place of the slot list until a duration is picked, so the duration
// choice gets deliberate focus instead of defaulting to the first option.
function DurationPrompt() {
  return (
    <EmptyState
      icon={<AccessTimeIcon sx={{ fontSize: "2.5rem", color: "primary.main" }} />}
      title="Choose a duration"
      description="Select a duration to see the available times for your lesson."
    />
  );
}

export default DurationPrompt;
